import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup } from 'reactstrap';
import { useForm } from "react-hook-form"
import axios from 'axios';
import useToken from '../../useToken';


export const AgentsAdd = ({ refetch, ...args }) => {
    const [modal, setModal] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const { token } = useToken();


    const toggle = () => {
        setModal(!modal);
    }
    const addCategories = async (data) => {
        const response = await axios.post(`/api/agents`, data, {
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                Authorization: "Bearer " + token
            }
        })

        if (response.status >= 200 || response.status <= 204) {
            setModal(false)
            refetch()
            reset()
        }
    }

    return (
        <div>
            <Button className='mb-2' color="success" size="sm" onClick={toggle}>
                Добавить
            </Button>
            <Modal isOpen={modal} toggle={toggle} {...args}>
                <form onSubmit={handleSubmit(addCategories)}>
                    <ModalHeader toggle={toggle}>Создать пользователя</ModalHeader>
                    <ModalBody>
                        <div className="mb-3">
                            <label htmlFor="operation" className="form-label">Наименование операции</label>
                            <input id="operation" name="operation" placeholder="Наименование операции" type="string" className="form-control"
                                {...register("operation", {
                                    required: { value: true, message: "Поле \"Наименование операции\" не может быть пустым" }
                                })} />
                            {errors.operation && <span className='text-danger'>{errors.operation?.message}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phones" className="form-label">Телефон (без +7)</label>
                            <input id="phones" name="phones" placeholder="Телефон" type="number" className="form-control"
                                {...register("phones", {
                                    required: { value: true, message: "Поле \"Телефон\" не может быть пустым" }
                                })} />
                            {errors.phones && <span className='text-danger'>{errors.phones?.message}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Наименование организации</label>
                            <input id="name" name="name" placeholder="Наименование организации" type="string" className="form-control"
                                {...register("name", {
                                    required: { value: true, message: "Поле \"Наименование организации\" не может быть пустым" }
                                })} />
                            {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="addres" className="form-label">Юр.адресс</label>
                            <input id="addres" name="addres" placeholder="Юр.адресс" type="string" className="form-control"
                                {...register("addres", {
                                    required: { value: true, message: "Поле \"Юр.адресс\" не может быть пустым" }
                                })} />
                            {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="tin" className="form-label">ИНН</label>
                            <input id="tin" name="tin" placeholder="ИНН" type="number" className="form-control"
                                {...register("tin", {
                                    required: { value: true, message: "Поле \"ИНН\" не может быть пустым" }
                                })} />
                            {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button color="success">
                                Добавить
                            </Button>
                            <Button color="warning" onClick={() => {
                                toggle()
                                reset()
                            }}>
                                Отмена
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </form>
            </Modal>
        </div>
    )

}